import SmiConstants from 'sg-smi-constants';
import _ from 'lodash';
import cookie from 'js-cookie';
import { SgGenerateRandomStringUtil } from 'saga-modules';
import SgSessionStorageService from 'sg-session-storage';

const getVosCookie = () => {
    return cookie.get(SmiConstants.SMI_COOKIES.VOS_COOKIE);
};

const getVosCookieAsBoolean = () => {
    return _.isNil(getVosCookie()) ? getVosCookie() : JSON.parse(getVosCookie());
};

const setVosCookie = (value) => {
    cookie.set(SmiConstants.SMI_COOKIES.VOS_COOKIE, value, { expires: SmiConstants.SMI_COOKIES.VOS_COOKIE_EXPIRATION_TIME });
};

const hasVosCookie = () => {
    return getVosCookie() !== undefined;
};

const getHealthSIDCookie = () => {
    return cookie.get(SmiConstants.SMI_COOKIES.HEALTH_SID_COOKIE);
};

const setHealthSIDCookie = (value) => {
    cookie.set(SmiConstants.SMI_COOKIES.HEALTH_SID_COOKIE, value);
};

const hasHealthSIDCookie = () => {
    return getHealthSIDCookie() !== undefined;
};

const generateHealthSIDCookieForTheSession = () => {
    const generatedHealthSID = SgGenerateRandomStringUtil.generateRandomString(SmiConstants.SMI_COOKIES.HEALTH_SID_COOKIE_SID_LENGTH);
    setHealthSIDCookie(generatedHealthSID);
    SgSessionStorageService.setItem(SgSessionStorageService.KEY.HEALTH_SID, generatedHealthSID);
};

const setCookiesOnRetrieval = (submission) => {
    if (!submission) {
        return;
    }
    const { hasPrivateHealthInsurance, previousInsurer } = submission.lobData.privateMedical.coverables.smiInsurance;
    const previousInsurerSelected = previousInsurer !== undefined && previousInsurer !== SmiConstants.PREVIOUS_INSURER_NONE_OPTION;
    const newCookieValue = hasPrivateHealthInsurance !== undefined
        ? hasPrivateHealthInsurance && previousInsurerSelected : previousInsurerSelected;
    setVosCookie(newCookieValue);
    generateHealthSIDCookieForTheSession();
};

export default {
    getVosCookieAsBoolean,
    setVosCookie,
    hasVosCookie,
    getHealthSIDCookie,
    setHealthSIDCookie,
    hasHealthSIDCookie,
    generateHealthSIDCookieForTheSession,
    setCookiesOnRetrieval
};
